
import React from "react";
import "./Loading.css";

export const Loading = ({what = ''}) => {
    return (<div className="Loading">{`${what}... `}</div>)
}

export default Loading